module.exports = __webpack_public_path__ + "f6be0f6d58bb988d66b0023f2231057c.png";